import request from "../utils/request.js";

// 获取url
export const queryUrl = data => {
    return request.post("/secondagent/valid/url", data);
};
